<edu-card class="settings-card">
  <h2 edu-card-title>Timezone</h2>
  <p class="desc">Set the platform timezone used to display dates and schedule sessions.</p>
  <p class="desc">
    This applies to every class timing shown for this organization, not just ones added
    after you change it — changing it re-anchors your whole existing schedule to the new
    zone.
  </p>

  <div class="timezone-grid">
    <div
      *ngFor="let tz of timezones"
      class="timezone-card"
      [class.selected]="selected() === tz.value"
      (click)="select(tz.value)"
    >
      <div class="tz-flag">{{ tz.flag }}</div>
      <div class="tz-info">
        <h3 class="tz-name">{{ tz.label }}</h3>
        <p class="tz-sub">{{ tz.offset }} · {{ tz.countries }}</p>
      </div>
      <div class="check-circle">
        <svg *ngIf="selected() === tz.value" width="10" height="10" viewBox="0 0 10 10">
          <polyline points="2,5 4,7.5 8,3" stroke="white" stroke-width="1.5"
            fill="none" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  </div>

  <div class="footer">
    <button class="link-button" (click)="save()" [disabled]="isSaving()">
      {{ isSaving() ? 'Saving...' : 'Save changes' }}
    </button>
  </div>
</edu-card>